import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { INFORM_STATUS, statusObj } from 'src/app/dummy/status';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { DataService } from 'src/app/services/data.service';
import { addMonth, yearOfDate, toDateKey, pageKey } from 'src/app/services/mapping.service';
import { ITerm } from 'src/app/interfaces/country';
import { AuthService } from 'src/app/auth/auth.service';
import { Term } from 'src/app/stores/administrator/term.store';
import { AuthStore } from 'src/app/stores/auth/auth.store';

@Component({
  selector: 'app-add-term',
  templateUrl: './add-term.component.html',
  styleUrls: ['./add-term.component.scss']
})
export class AddTermComponent implements OnInit {
  @ViewChild("focusInput", { static: false }) inputRef: ElementRef;
  form: FormGroup;
  name: AbstractControl
  code: AbstractControl
  startTermDate: AbstractControl
  closedTermDate: AbstractControl
  startEnrollDate: AbstractControl
  closedEnrollDate: AbstractControl
  closedPaymentDate: AbstractControl
  maxEnrollSubject: AbstractControl
  academicYear: AbstractControl;
  informStatus: AbstractControl;
  closedDropDate: AbstractControl;
  note: AbstractControl
  memo: AbstractControl

  INFORMSTATUS = INFORM_STATUS;
  constructor(
    public dialogRef: MatDialogRef<AddTermComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
        public auth: AuthStore,
    private snackBar: MatSnackBar,
    public store: Term,
    public ds: DataService,
  ) { }

  buildForm(): void {
    this.form = this.fb.group({
      name: [null, Validators.required],
      code: [null, Validators.required],
      startTermDate: [new Date(), Validators.required],
      closedTermDate: [addMonth(3), Validators.required],
      startEnrollDate: [new Date(), Validators.required],
      closedEnrollDate: [addMonth(1), Validators.required],
      closedPaymentDate: [addMonth(2), Validators.required],
      closedDropDate: [addMonth(1), Validators.required],
      maxEnrollSubject: [0, Validators.required],
      academicYear: [yearOfDate(new Date()), Validators.required],
      informStatus: [this.INFORMSTATUS[0], Validators.required],
      note: [null],
      memo: [null],
    })
    this.name = this.form.controls['name'];
    this.code = this.form.controls['code'];
    this.startTermDate = this.form.controls['startTermDate'];
    this.closedTermDate = this.form.controls['closedTermDate'];
    this.startEnrollDate = this.form.controls['startEnrollDate'];
    this.closedEnrollDate = this.form.controls['closedEnrollDate'];
    this.closedPaymentDate = this.form.controls['closedPaymentDate'];
    this.maxEnrollSubject = this.form.controls['maxEnrollSubject'];
    this.academicYear = this.form.controls['academicYear'];
    this.informStatus = this.form.controls['informStatus'];
    this.closedDropDate = this.form.controls['closedDropDate'];
    this.note = this.form.controls['note'];
    this.memo = this.form.controls['memo'];
  }


  compareObjects(o1: any, o2: any): boolean {
    if (o2) return o1.name === o2.name;
  }

  ngOnInit() {
    this.buildForm();
  }

  create(f: any, isNew) {
    if (this.form.valid) {
      this.form.disable()
      const { code, name, startTermDate, closedTermDate, startEnrollDate, closedEnrollDate,
        closedPaymentDate, closedDropDate, maxEnrollSubject, academicYear, informStatus, note, memo } = f;
      const { UNIVERSITY_LEVEL } = this.auth.config;
      const item: ITerm = {
        key: this.ds.createId(),
        page_key: pageKey(),
        created_date: new Date(),
        created_by: this.ds.userRef().doc(`${this.auth.user.uid}`).ref,
        isDeleted: false,
        status: statusObj.active,
        termType: this.data,
        startTermDateKey: toDateKey(startTermDate),
        closedTermDateKey: toDateKey(closedTermDate),
        startEnrollDateKey: toDateKey(startEnrollDate),
        closedEnrollDateKey: toDateKey(closedEnrollDate),
        closedPaymentDateKey: toDateKey(closedPaymentDate),
        closedDropDateKey: toDateKey(closedDropDate),
        code,
        name, startTermDate, closedTermDate, startEnrollDate, closedEnrollDate,
        closedPaymentDate, closedDropDate, maxEnrollSubject, academicYear, informStatus, note, memo,
        levelKey: UNIVERSITY_LEVEL?UNIVERSITY_LEVEL:null,
        levelRef: UNIVERSITY_LEVEL?this.ds.levelRef().doc(`${UNIVERSITY_LEVEL}`).ref:null,
        isCurrent:false
      }
      this.store.save(this.ds.termRef(), item, (success, res) => {
        if (success) {
          if (!isNew) {
            this.dialogRef.close();
          }
          this.snackBar.open('Shift has been created.', 'done', { duration: 3000 });
          this.form.reset();
          this.form.enable();
          this.form.patchValue({
            startTermDate, closedTermDate, startEnrollDate, closedEnrollDate, closedPaymentDate, closedDropDate, informStatus, academicYear, maxEnrollSubject
          })
          this.inputRef.nativeElement.focus();
        } else {
          alert(res);
        }
      })
    }
  }

}
